/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { isNumber, isString } from 'remeda'
import styled, { css, type DefaultTheme } from 'styled-components'
import type { TypographyColor } from '@velasca/types'
import type { TitleProps } from './SerifTitle.types'

const getColor = (theme: DefaultTheme, color?: TypographyColor) => {
  switch (color) {
    case 'primary': {
      return theme.colors.primary
    }
    case 'light': {
      return theme.colors.primaryLight
    }
    case 'white': {
      return theme.colors.text.secondary
    }
    default: {
      return theme.colors.text.primary
    }
  }
}

export const Title = styled.h1<TitleProps>`
  font-family: ${({ theme }) => {
    return theme.fonts.serif.fontFamily
  }};
  font-weight: 400;
  line-height: 125%;
  margin: ${({ margin }) => {
    if (isNumber(margin)) {
      return `${margin}px`
    }

    if (isString(margin)) {
      return margin
    }

    return '0'
  }};

  padding: ${({ padding }) => {
    if (isNumber(padding)) {
      return `${padding}px`
    }

    if (isString(padding)) {
      return padding
    }

    return '0'
  }};

  ${({ center }) => {
    return (
      center &&
      css`
        text-align: center;
      `
    )
  }}

  p {
    font-size: inherit;
    line-height: inherit;
    margin-bottom: 0;
  }

  ${({ theme, color }) => {
    return css`
      color: ${getColor(theme, color)};
    `
  }}

  ${({ size }) => {
    switch (size) {
      case 'xs': {
        return css`
          font-size: 18px;
          letter-spacing: -1px;
        `
      }
      case 'sm': {
        return css`
          font-size: 20px;
          letter-spacing: -1px;
        `
      }
      case 'md': {
        return css`
          font-size: 30px;
          letter-spacing: -2px;
        `
      }
      case 'lg': {
        return css`
          font-size: 36px;
          letter-spacing: -2px;
        `
      }
      case 'xl': {
        return css`
          font-size: 50px;
          letter-spacing: -3px;
        `
      }
      default: {
        return css`
          font-size: 24px;
          letter-spacing: -1px;
        `
      }
    }
  }}
`
